import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./AddTaskFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

import AddTaskStepOne from "../AddTaskSteps/AddTaskStepOne";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

const AddTaskForm = (props) => {
  const theme = useTheme();
  const { step, setStep, updateTask, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  const [workers, setWorkers] = useState([]);

  useEffect(() => {
    if (updateTask) {
      setInitialValues({
        ..._initialValues,
        clientType: _initialValues?.clientType
          ? { value: _initialValues?.clientType }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    const workersFetch = GlobalAuthFetch({ path: "/worker/all" });

    const [workersPayload] = await Promise.all([workersFetch]);

    setWorkers(workersPayload?.payload?.data);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={false}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="AddProjectForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <AddTaskStepOne {...formProps} {...props} workers={workers} />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default AddTaskForm;
